import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

// import { PreviewService } from './../../services/preview.service';
// import { PushXService } from './../../../shared-postlogin/services/pushx.service';
import { CustomBackendLoggerService } from './../../../app/services/custom-backend-logger.service';
import { AppHelperService } from 'modules/app/services/app-helper.service';

@Component({
    selector: 'preview',
    template: ``,
    standalone: false
})
export class Preview implements OnInit {
    params : any;

    constructor(private router: Router,
        private route: ActivatedRoute, 
        // private previewService : PreviewService,
        // private pushXService : PushXService,
        private customBackendLoggerService : CustomBackendLoggerService,
        private appHelperService: AppHelperService
    ) {

    }

    ngOnInit() {

        this.params = this.route.snapshot.queryParamMap['params'];
    
        if(/*this.params.token && this.params.orgid  && this.params.userid &&*/
            /*this.params.spaceid && this.params.extid &&*/ this.params.productcode && this.params.stage) {
                // const previewData = {
                //     token : this.params.token,
                //     orgId : this.params.orgid,
                //     dlsUuid : this.params.userid, 
                //     spaceId : this.params.spaceid,
                //     extUserId : this.params.extid
                // }

                // this.previewService.loginPreviewMode(previewData).subscribe((response)=> {
                    // const pushXConnection = this.pushXService.getPushXConnection(this.params.orgid);
                    // const channelObj = {userid: this.params.userid, orgid: this.params.orgid, channel: 'systemevents.PRODUCT.USER_ENTITLEMENT_ADD'};

                    // pushXConnection.on(channelObj, (eventContext) => {
                    //     this.customBackendLoggerService.logInfoToBackend({
                    //         'params' : this.params,
                    //         'context' : 'TYPE=SYSTEM_EVENTS, Preview Product',
                    //         'event': eventContext
                    //     }).subscribe();

                    //     if(eventContext.events && eventContext.events.body
                    //         && eventContext.events.body.productcode == this.params.productcode
                    //         && eventContext.events.body.userid == this.params.userid) {
                    //         if( eventContext.events.body.status == "success") {
                    //             this.router.navigate(['/learner', this.params.spaceid, 'product', this.params.productcode], { queryParams: {preview : true, stage : this.params.stage}})
                    //         } else if(eventContext.events.body.status == "error") {
                    //             this.appHelperService.navigateToDashboardApp(['error']); 
                    //         }                    
                    //     }  
                    // });

                    // pushXConnection.on({ channel: "pushx_status" }, (subscriptionStatus) => {
                    //     if(subscriptionStatus.category === 'PUSHX' && subscriptionStatus.type === 'CHANNEL_SUBSCRIPTION') {
                    //         if(subscriptionStatus.status === 'SUCCESS') {
                                // this.previewService.userProductEntitlement(previewData.spaceId, this.params.productcode, this.params.stage)
                                // .subscribe((res : any) => {
                                    // if(res.status_code == 200) {
                                        this.router.navigate(['/teacher', 'dummy', 'product', this.params.productcode], { queryParams: {preview : true, stage : this.params.stage}});
                                    // }
                                // });
                    //         } else if(subscriptionStatus.status === 'ERROR') {
                    //             throw new Error(JSON.stringify(subscriptionStatus));
                    //         }
                    //     }
                    // });
                // })
                
        } else {
            this.customBackendLoggerService.logInfoToBackend({
                'params' : this.params,
                'context' : 'TYPE=PREVIEW_PRODUCT_ERROR'
            }).subscribe();
            this.appHelperService.navigateToDashboardApp(['error']);
        }
    }
    
    // ngOnDestroy() {
    //     this.pushXService.cleanup();
    // }
}
